export default {
    AYUNTAMIENTO: 'Ayuntamiento',
    COMUNIDAD_DE_BIENES: 'Comunidad de bienes',
    FUNDACION: 'Fundación',
    INSTITUCIONAL: 'Institucional',
    ENTIDAD_DE_CREDITO: 'Entidad de credito',
    EMPRESA_DE_SEGUROS: 'Empresa de seguros',
    FONDO_DE_PENSIONES: 'Fondo de pensiones',
    INSTITUCION_INVERSION_COLECTIVA_IFM: 'Institución inversión colectiva IFM',
    INSTITUCION_INVERSION_COLECTIVA_NO_IFM: 'Institución inversión colectiva no IFM',
    AUXILIARES_FINANCIEROS: 'Auxiliares financieros',
    OTROS_INTERMEDIARIOS_FINANCIEROS: 'Otros intermediarios financieros',
    SOCIEDADES_NO_FINANCIALES: 'Sociedades no financiales'
};
